import React from "react";

const Footer = () => {
  return (
    <div
      style={{
        width: "100%",
        backgroundImage:
          "radial-gradient(circle, #582b70, #442759, #332142, #231b2b, #141315)",
        color: "white",
        textAlign: "center",
      }}
    >
      <p>&copy; 2024 Türkiye Zeka Vakfı. Tüm hakları saklıdır.</p>
    </div>
  );
};

export default Footer;
